module.exports = __webpack_public_path__ + "static/media/Teilnahmebedingungen.5eac670c.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/Teilnahmebedingungen.docx
// module id = 1517
// module chunks = 0